var _path, _path2, _path3, _path4, _path5, _path6, _rect, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOutstaffing(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.356 23C37.356 24.8385 36.9938 26.659 36.2903 28.3576C35.5867 30.0561 34.5555 31.5995 33.2555 32.8995C31.9554 34.1995 30.4121 35.2307 28.7135 35.9343C27.015 36.6379 25.1945 37 23.356 37",
    stroke: "#2E2E2E",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.35596 23C7.35596 24.8385 7.71808 26.659 8.42164 28.3576C9.12521 30.0561 10.1564 31.5995 11.4565 32.8995C12.7565 34.1995 14.2998 35.2307 15.9984 35.9343C17.6969 36.6379 19.5175 37 21.356 37",
    stroke: "#2E2E2E",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.356 7C25.1945 7 27.015 7.36212 28.7135 8.06569C30.4121 8.76925 31.9554 9.80048 33.2555 11.1005C34.5555 12.4005 35.5867 13.9439 36.2903 15.6424C36.9938 17.341 37.356 19.1615 37.356 21",
    stroke: "#2E2E2E",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.3583 21.6901C38.1272 22.0278 37.666 22.1142 37.3283 21.8831L31.8251 18.1165C31.4874 17.8853 31.4011 17.4242 31.6322 17.0865C31.8633 16.7488 32.3245 16.6624 32.6622 16.8935L37.5539 20.2416L40.902 15.3499C41.1331 15.0122 41.5943 14.9258 41.932 15.1569C42.2697 15.3881 42.356 15.8492 42.1249 16.1869L38.3583 21.6901Z",
    fill: "#2E2E2E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.50995 21.7842C8.22207 21.4934 7.75292 21.491 7.46207 21.7788L2.72245 26.4701C2.43161 26.758 2.4292 27.2272 2.71708 27.518C3.00497 27.8089 3.47412 27.8113 3.76496 27.5234L7.97796 23.3533L12.148 27.5663C12.4359 27.8572 12.905 27.8596 13.1959 27.5717C13.4867 27.2838 13.4891 26.8147 13.2013 26.5238L8.50995 21.7842Z",
    fill: "#2E2E2E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.356 7C19.5175 7 17.6969 7.36212 15.9984 8.06569C14.2998 8.76925 12.7565 9.80048 11.4565 11.1005C10.1564 12.4005 9.12521 13.9439 8.42164 15.6424C7.71808 17.341 7.35596 19.1615 7.35596 21",
    stroke: "#2E2E2E",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20.8555,
    y: 15,
    width: 2.75757,
    height: 4.66059,
    rx: 1.24504,
    stroke: "#C63031",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.001 24.0176C18.001 23.2506 18.4235 22.6224 19.0365 22.3917C20.0536 22.009 21.2672 21.6602 22.2343 21.6602C23.2014 21.6602 24.415 22.009 25.4321 22.3917C26.0451 22.6224 26.4676 23.2506 26.4676 24.0176V27.2723H18.001V24.0176Z",
    stroke: "#C63031",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutstaffing);
export default __webpack_public_path__ + "static/media/Outstaffing.14d065e028fc1a7a4fa50f0351e6816f.svg";
export { ForwardRef as ReactComponent };